module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GR - Greece.896a4dfd.svg";